/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_AddInputs */

const en_disabled_websites_add = /** @type {(inputs: Disabled_Websites_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to Disabled Websites`)
};

const es_disabled_websites_add = /** @type {(inputs: Disabled_Websites_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar a sitios deshabilitados`)
};

/**
* | output |
* | --- |
* | "Add to Disabled Websites" |
*
* @param {Disabled_Websites_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_add = /** @type {((inputs?: Disabled_Websites_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_add(inputs)
	return en_disabled_websites_add(inputs)
});